import { GoodType } from "../types";

export const normalizeFormData = (data: GoodType) => {
    return {
        ...data,
        price: Number(data.price),
        quantity: Number(data.quantity),
    };
};
